<script>
  import { longpress } from "../utils/actions.js";
  export let min = "00";
  export let sec = "20";

  function increment() {
    sec = Number(sec);
    min = Number(min);
    sec += 1;
    if (sec < 10) {
      sec = "0" + sec;
    }
    if (sec > 59) {
      sec = "0" + 0;
      min += 1;
      if (min > 99) {
        min = 99;
        sec = 59;
      }
    }
    if (min < 10) {
      min = "0" + min;
    }
  }

  function subtract() {
    sec = Number(sec);
    min = Number(min);
    if (sec != 0) {
      sec -= 1;
    } else {
      if (min > 0) {
        min -= 1;
        sec = 59;
      }
    }
    if (min < 10) {
      min = "0" + min;
    }
    if (sec < 10) {
      sec = "0" + sec;
    }
  }

  function onChangeMin() {
    min = Math.trunc(Number(min));
    if (min > 99) {
      min = 99;
    }
    if (min < 0) {
      min = 0;
    }
    if (min < 10) {
      min = "0" + min;
    }
    min = "" + min;
  }

  function onChangeSec() {
    sec = Math.trunc(Number(sec));
    if (sec > 59) {
      sec = 59;
    }
    if (sec < 0) {
      sec = 0;
    }
    if (sec < 10) {
      sec = "0" + sec;
    }
    sec = "" + sec;
  }
</script>

<div class="flex flex-row justify-between items-center w-full space-x-2">
  <button
    data-action="decrement"
    aria-label="Subtract"
    class="btn"
    on:click={subtract}
    use:longpress
    on:longpressstart={subtract}
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="h-8 w-8"
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path
        fill-rule="evenodd"
        d="M10 18a8 8 0 100-16 8 8 0 000 16zM7 9a1 1 0 000 2h6a1 1 0 100-2H7z"
        clip-rule="evenodd"
      />
    </svg>
  </button>
  <div
    class="group focus-within:ring-4 ring-yellow-400 ring-opacity-30 flex flex-col justify-center items-center rounded-2xl"
  >
    <input
      aria-label="Min"
      type="number"
      class="font-semibold text-2xl  bg-yellow-400 py-1 border-0 rounded-t-2xl border-gray-200 focus:ring-0 text-center w-14"
      name="custom-input-number"
      bind:value={min}
      on:change={onChangeMin}
      on:input={onChangeMin}
      min="0"
      max="99"
    />
    <span class="text-xxs w-full text-center py-1 bg-gray-900 rounded-b-2xl"
      >min</span
    >
  </div>
  <span class="text-2xl">:</span>
  <div
    class="group focus-within:ring-4 ring-green-400 ring-opacity-30 flex flex-col justify-center items-center rounded-2xl"
  >
    <input
      aria-label="Sec"
      type="number"
      class="font-semibold text-2xl bg-green-400 mt-0 py-1 border-0 rounded-t-2xl border-gray-200 focus:ring-0 text-center w-14"
      name="custom-input-number"
      bind:value={sec}
      on:change={onChangeSec}
      on:input={onChangeSec}
      min="0"
      max="59"
    />
    <span class="text-xxs w-full text-center py-1 bg-gray-900 rounded-b-2xl"
      >sec</span
    >
  </div>
  <button
    data-action="increment"
    class="btn"
    aria-label="Increment"
    on:click={increment}
    use:longpress
    on:longpressstart={increment}
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="h-8 w-8"
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path
        fill-rule="evenodd"
        d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z"
        clip-rule="evenodd"
      />
    </svg>
  </button>
</div>
